import React from 'react';
import styles from './PriceLabelFrames.module.scss';

interface PriceLabelFramesProps {
    onClick?: () => void;
}
// price needs to be updated to the correct value and language
const PriceLabelFramesComponent = ({ onClick }: PriceLabelFramesProps) => {
    return (
        <span className={styles.PriceLabelFrames}>
            € 0,10 p.st.
        </span>
    );
};

export const PriceLabelFrames = React.memo(PriceLabelFramesComponent);